import api from 'src/config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import Rank from 'src/interfaces/api/Ranking';
import { CollectionResponse } from 'src/interfaces/api/api';
import useAuth from './useAuth';

const useRanking = () => {
  const { fetch } = useAuth();

  const getAll = async (): Promise<CollectionResponse<Rank>> => {
    const { endpoint, ...options } = api.ranking.getAll();

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Rank>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getAll };
};

export default useRanking;
